import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8np3hwxg3: FaireProductEntity = {
  token: "p_e8np3hwxg3",
  type: "product",
  name: "Crystal Cats",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Chaotic Crystal Chick Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/700f4c28001a6c269fc37eae3f5aca89a5c5f5445138304da80e01c1a837473f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7472d23f043c2fd1f59c6e90fdd97e4f1cc49c9788224d1a3491925dd9b1da6.jpeg",
  ],
  priceDollars: 9.98,
  description:
    "Choose the material of your fun crystal carving. Many of our carvings have multiple materials available and while we will try to update photos when new materials come in, there may be a gap in some updates. Please note most photos are the exact piece you will get, however sometimes we have duplicate shapes in the same material so there may be some variant in what you receive as these are natural crystals and minerals and no two pieces are exactly alike.\n",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:21.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
